<section class="has-padding-block-3 animated fadeIn">
  <div class="title is-center">
    <h2 class="title__main">How it Works</h2>
    <p class="title__sub">Getting your hands on high-quality produce and groceries has never been easier.
      Sign up now and let the freshness come to you!</p>
  </div>
  <div class="row mt-5">
    <div class="col-md-4">
      <div class="how-step">
        <span class="icon material-symbols-outlined">share_location</span>
        <div class="detail">
          <div class="num">1</div>
          <div class="text">
            Enter your delivery address
            <br>
            Click <a
              href="https://www.google.com/maps/d/u/0/viewer?mid=1BEjE30doE8rTuzSafIUjhlYjXoP4wsY&ll=39.621826902908076%2C-75.03865350000001&z=9"
              target="_blank">here</a> to see a delivery map
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="how-step">
        <span class="icon material-symbols-outlined">person_edit</span>
        <div class="detail">
          <div class="num">2</div>
          <div class="text">Pick your delivery window and create your FREE account</div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="how-step has-no-dash">
        <span class="icon material-symbols-outlined">add_shopping_cart</span>
        <div class="detail">
          <div class="num">3</div>
          <div class="text">Select recurring food shares and customize/shop when the market opens</div>
        </div>
      </div>
    </div>
    <div class="btn-wrap is-center">
      <a class="btn btn-secondary" routerLink='/signup'>Sign up</a>
    </div>
  </div>
</section>
<hr class="is-thick">
<section>
  <div class="container-md px-lg-5">
    <h2 class="section-title text-center">Select recurring produce and food item shares</h2>
    <p class="text-center">Choose from a range of different share boxes to get a hand-picked bounty of seasonal
      fruits and
      vegetables, breads, and other grocery staples delivered to your door every week, every other week, or once
      a month.</p>
    <div class="cards-wrap">
      <div class="row">
        <div class="col-lg-4 col-sm-6 mb-4" *ngFor="let item of foodItem">
          <div class="card">
            <div class="card-body">
              <h3 class="card-title mb-2">{{item.title}}</h3>
              <img src="{{item.img}}" class="card-img" alt="{{item.title}}">
              <p class="card-tag mb-0">{{item.text}}</p>
            </div>
            <div class="card-footer">
              <a href="#" class="btn btn-secondary" routerLink='/shop'>Shop now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="btn-wrap is-center">
    <a class="btn btn-secondary" routerLink='/signup'>Register for a Philly Foodworks Account</a>
  </div>
</section>
<hr class="is-thick">
<section class="has-padding-block-1">
  <div class="container-md px-lg-5">
    <h2 class="section-title text-center">Shop online for your weekly groceries</h2>
    <p class="text-center">Build your order from scratch each week by selecting what interests you from the market, or
      add extra
      items to your chosen share box(es)</p>
    <div class="cards-wrap">
      <div class="row">
        <div class="col-lg-4 col-sm-6 mb-4" *ngFor="let item of weeklyGroceries">
          <div class="card">
            <div class="card-body">
              <h3 class="card-title">{{item.title}}</h3>
              <img src="{{item.img}}" class="card-img" alt="{{item.title}}">
            </div>
            <div class="card-footer">
              <a routerLink='/shop/{{item.url}}' class="btn btn-secondary"><span
                  class="btn-icon material-symbols-outlined">search</span>Check
                the market</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
